// Copyright (c) 2021, Comsearch, Inc., All rights reserved

import { BULK_EDITS_FILTER } from 'components/BulkUpdates/constants'
import { castToFloat } from 'helpers/reduxFormFunctions'

const getBulkEditPathsFilteredByBandId = () => (dispatch, getState) => {
  const {
    bulkEdit,
    form,
  } = getState()

  const filterFormValues = form[BULK_EDITS_FILTER].values

  const bandId = castToFloat(filterFormValues.bandId)

  return (
    bulkEdit
      .get('bulkEditPaths')
      .filter(d => d.get('bandId') === bandId)
  )
}

export default getBulkEditPathsFilteredByBandId
